import * as React from 'react';
import {observer} from 'mobx-react';
import bind from 'bind-decorator';
import {IWidgetComponentProps} from '@mintdata-wsp/wsp/ui/views/visualDesigner/flow/panels/properties/widgets/FlowPropertiesWidgets';
import {Checkbox} from '@mintdata/mint-kit/impl/properties/components/checkbox/Checkbox';

@observer
export class CheckboxWidget extends React.Component<IWidgetComponentProps, any>
{
    public static defaultProps:Partial<IWidgetComponentProps> = {
        isOutlined: true,
    };

    @bind
    private _onClick(e:React.FormEvent<any>)
    {
        const {onChange, prop} = this.props;
        const {value} = prop;

        onChange(!value);
    }

    render()
    {
        const {
            prop,
            inlineLabel,
        } = this.props;

        const {value} = prop;

        return (
            <Checkbox
                inlineLabel={inlineLabel}
                isChecked={!!value}
                onClick={this._onClick}
            />
        );
    }
}
